import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { TSecurityContentBlockDesktop, IDepsDesktop } from '../models';

import { SecurityContentBlockDesktop as Component } from './security-content-block';

export const SecurityContentBlockDesktop = createWidget<IDepsDesktop, TSecurityContentBlockDesktop>(
    {
        Block,
        Text,
    }
)(Component);
